import React, { useRef } from 'react';
import { useScrollScene } from './motion';

const TEXT = 'We design, secure and run the technology that keeps banks, enterprises and governments moving across Africa and Europe.';
const WORDS = TEXT.split(' ');
const ACCENT = new Set(['secure', 'Africa', 'Europe.']);

// Words light up one by one as the section scrolls.
const StatementSection = () => {
  const ref = useRef(null);
  const words = useRef([]);
  useScrollScene(ref, (p) => {
    const lit = p * 1.25 * WORDS.length;
    words.current.forEach((el, i) => { if (el) el.style.opacity = Math.min(1, Math.max(0.14, lit - i)); });
  });
  return (
    <section id="statement" ref={ref} className="relative h-[135vh]">
      <div className="sticky top-0 h-screen flex items-center">
        <p className="max-w-5xl mx-auto px-6 font-display text-4xl sm:text-6xl lg:text-7xl leading-[1.08]">
          {WORDS.map((w, i) => (
            <span key={i} ref={(el) => (words.current[i] = el)} className={ACCENT.has(w) ? 'text-[var(--red)] italic' : ''} style={{ opacity: 0.14 }}>{w} </span>
          ))}
        </p>
      </div>
    </section>
  );
};

export default StatementSection;
